import {fromEvent, merge} from 'rxjs';

const animationEnd = async (element) => new Promise(resolve => {
    const transitionEnd$ = fromEvent(element, 'transitionend', {once: true});
    const animationEnd$ = fromEvent(element, 'animationend', {once: true});

    const subscription = merge(
        transitionEnd$,
        animationEnd$
    ).subscribe(() => {
        subscription.unsubscribe();
        resolve();
    });
})

/**
 * @typedef {object} AnimationOptions
 * @property {string} class
 * @property {string} activeClass
 * @property {string} toClass
 */

/**
 *
 * @param {HTMLElement} element
 * @param {AnimationOptions} options
 */
export default function getPlayback(element, {class: _class, activeClass, toClass}) {
    const done = animationEnd(element);

    done.then(() => {
        element.classList.remove(_class);
        element.classList.replace(activeClass, toClass);
    });

    element.classList.add(_class);

    return {
        play: () => element.classList.add(activeClass),
        done,
    }
}
